import React from 'react';
import { StudentForm } from './StudentForm';

const BlueShape: React.FC = () => (
  <div className="w-full h-full rounded-full bg-white" />
);

export const StudentBlue: React.FC = () => {
  return (
    <StudentForm
      backgroundColor="#4558C8"
      ShapeIcon={BlueShape}
    />
  );
};